export const baseEndpoint = '/v1/opportunities/$id/proposed-project';

export const proposedProjectConfigs = {
	get_environmental_report: {
		method: 'GET',
		endpoint: `${baseEndpoint}/environmental-report`
	},
	update_environmental_report: {
		method: 'PUT',
		endpoint: `${baseEndpoint}/environmental-report`,
	},

	get_existing_financing: {
		method: 'GET',
		endpoint: `${baseEndpoint}/existing-financing`
	},
	update_existing_financing: {
		method: 'PUT',
		endpoint: `${baseEndpoint}/existing-financing`,
	},

	get_geotechnical_report: {
		method: 'GET',
		endpoint: `${baseEndpoint}/geotechnical-report`
	},
	update_geotechnical_report: {
		method: 'PUT',
		endpoint: `${baseEndpoint}/geotechnical-report`,
	},

	get_overview: {
		method: 'GET',
		endpoint: `${baseEndpoint}/overview`
	},
	update_overview: {
		method: 'PUT',
		endpoint: `${baseEndpoint}/overview`,
	},

	get_permits: {
		method: 'GET',
		endpoint: `${baseEndpoint}/permits`
	},
	update_permits: {
		method: 'PUT',
		endpoint: `${baseEndpoint}/permits`,
	},
	get_schedules: {
		method: 'GET',
		endpoint: `${baseEndpoint}/schedules`
	},
	update_schedules: {
		method: 'PUT',
		endpoint: `${baseEndpoint}/schedules`,
	},

	get_marketing_strategy: {
		method: 'GET',
		endpoint: `${baseEndpoint}/marketing`
	},
	update_marketing_strategy: {
		method: 'PUT',
		endpoint: `${baseEndpoint}/marketing`,
	},

	get_project_appraisal: {
		method: 'GET',
		endpoint: `${baseEndpoint}/project-appraisal`
	},
	update_project_appraisal: {
		method: 'PUT',
		endpoint: `${baseEndpoint}/project-appraisal`,
	},

	get_secured_property_details: {
		method: 'GET',
		endpoint: `${baseEndpoint}/secured-property-details`
	},
	update_secured_property_details: {
		method: 'PUT',
		endpoint: `${baseEndpoint}/secured-property-details`,
	}
}
